<template>
	<div class="home">
		<EncabezadoRecuperacionPass></EncabezadoRecuperacionPass>

		<div id="content" class="snap-content bg-home">
			<div class="container">
                    
				&#xFEFF;
				
				<div class="header-clear mt-15"></div>
				
				<div class="row" v-if="!correoRecuperacionContraseniaEnviado">
					<div class="col-md-12">
						<h3 class="mt-0 text-center">Solicitud Nueva Contraseña</h3>
						<hr />
					</div>
				</div>
				
				<div class="row">
					<div class="col-md-4"></div>
					<div class="col-md-4" v-if="correoRecuperacionContraseniaEnviado">
						<h2>Solicitud Nueva Contraseña</h2>
						<h5>Email enviado. Por favor, revise su bandeja de entrada, incluída la carpeta de SPAM</h5>
						<h5>Si no recibiese ningún mensaje de correo compruebe que el email indicado está dado de alta en Recursos Humanos</h5>
					</div>
					<div class="col-md-4" v-else>
				
					<form 
						id="formSolicitudNuevaContrasenia" 
						class="form-horizontal"
						@submit.prevent="enviarCorreo"
					>
					<p align="justify">Introduce el email que tengas registrado en tu CASI. Si todavía no tienes ninguno, ponte en contacto con tu responsable.</p>
					<hr />
				<div class="validation-summary-valid text-danger" data-valmsg-summary="true">
					<ul>
						<li style="display:none"></li>
					</ul>
				</div>
				<label class="control-label" for="Email">Email</label>
				<input v-model="email" class="form-control" id="email" name="email" type="email" ref="email" required />
				<div>&nbsp;</div>
				<small id="emailHelp" class="form-text text-muted">Tenga en cuenta que jamás compartiremos su dirección de email.</small>
				<div>&nbsp;</div>
				<div class="row log-sec">
					<div class="col-md-6">
						<input type="submit" class="btn btn-success" value="Enviar">
					</div>
					<div class="col-md-6">
						<input type="button" class="btn btn-success" value="Cancelar" @click="cancelar();">
					</div>
				</div>
				</form>  
				</div>
					<div class="col-md-4"></div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
    // @ is an alias to /src
    import EncabezadoRecuperacionPass from "@/components/EncabezadoRecuperacionPass.vue";
    import Footer from "@/components/Footer.vue";

    export default {
		name: "SolicitudNuevaContrasenia",
        components: {
            EncabezadoRecuperacionPass,
            Footer,
        },
		data() {
			return {
				email:''
			}
		},
		created(){
			this.email='';
			this.$store.commit('establecerEnvioCorreoRecuperacionPass', false);
		},
		mounted() {
			document.body.classList.remove("bg-login");
			document.body.classList.remove("login-page");
			this.$refs.email.focus();
		},
		methods:{
			enviarCorreo(){
				this.$store.dispatch({
					type: 'enviarCorreoRecuperacionPass',
					email: this.email
				});
			},
			cancelar(){
				const target = window['cordova_iab'] ??
				window['webkit']?.messageHandlers['cordova_iab'] ??
				window['opener'] ??
				window['parent'] ??
				window;

				const data = JSON.stringify({event: 'cancel'});

				target.postMessage(data, "*");

				window.location.href = '/';
			}
		},
		computed:{
			correoRecuperacionContraseniaEnviado: function(){
				return this.$store.state.correoRecuperacionContraseniaEnviado;
			}
		}
    };
</script>

<style>
    @import "../assets/styles/home.css";
</style>
